import React from "react";
import "../styles/Registration.css";
import { Link } from "react-router-dom";

function Registration() {
  return (
    <div className="registration-ru">
      <h1>Регистрация</h1>
      <div className="registration-form-container">
        <div className="registration-text">
          Для участия в отборочном этапе Кубка CTF России 2024 необходимо пройти
          простую регистрацию: указать информацию о себе и своей команде.
        </div>
        <div className="registration-button">
          <div className="registration-button--text">
            Форма регистрации российских команд
          </div>
          <Link to="/registration-ru">
            <button className="partners__join-button">Регистрация</button>
          </Link>
        </div>
        <div className="registration-button">
          <div className="registration-button--text">
            Registration form foreign teams
          </div>
          <Link to="/registration-foreign">
            <button className="partners__join-button">Register</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Registration;
